module.exports = __webpack_public_path__ + "media/honey-icons/icon-right-gray-lightest-3609ae57.svg";